// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-page-login .lsn-login-header {
  margin: 30px 0px;
}
.lsn-page-login .form-errors {
  margin-bottom: 1rem;
}
.lsn-page-login .forgot-password-links {
  display: flex;
  justify-content: space-between;
}
.lsn-page-login .forgot-password-links a:last-child {
  text-align: right;
}
.lsn-page-login .lsn-password-link {
  color: var(--main-red) !important;
  font-size: var(--main-font-size-links);
  text-decoration: underline;
}
.lsn-page-login .lsn-timeout-banner-message {
  background-color: var(--main-primary-color);
  color: var(--main-white);
  margin: 0;
  text-align: center;
  position: relative;
  padding: 10px 0 10px 0;
}
.lsn-page-login .lsn-timeout-banner-message .lsn-timeout-banner-text {
  color: var(--main-white);
  font-weight: bold;
  text-align: center;
}
.lsn-page-login .lsn-login-account-desc {
  margin-block: 0.5rem;
  font-weight: bolder;
}
.lsn-page-login button.create-account {
  margin-top: 1rem;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ;AAFA;EAMI,mBAAA;AADJ;AALA;EAUI,aAAA;EACA,8BAAA;AAFJ;AATA;EAcM,iBAAA;AAFN;AAZA;EAmBI,iCAAA;EACA,sCAAA;EACA,0BAAA;AAJJ;AAjBA;EAyBI,2CAAA;EACA,wBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAzBA;EAiCM,wBAAA;EACA,iBAAA;EACA,kBAAA;AALN;AA9BA;EAwCI,oBAAA;EACA,mBAAA;AAPJ;AAlCA;EA6CI,gBAAA;EACA,WAAA;AARJ","sourcesContent":[".lsn-page-login {\n  .lsn-login-header {\n    margin: 30px 0px;\n  }\n\n  .form-errors {\n    margin-bottom: 1rem;\n  }\n\n  .forgot-password-links {\n    display: flex;\n    justify-content: space-between;\n\n    a:last-child {\n      text-align: right;\n    }\n  }\n\n  .lsn-password-link {\n    color: var(--main-red) !important;\n    font-size: var(--main-font-size-links);\n    text-decoration: underline;\n  }\n\n  .lsn-timeout-banner-message {\n    background-color: var(--main-primary-color);\n    color: var(--main-white);\n    margin: 0;\n    text-align: center;\n    position: relative;\n    padding: 10px 0 10px 0;\n\n    .lsn-timeout-banner-text {\n      color: var(--main-white);\n      font-weight: bold;\n      text-align: center;\n    }\n  }\n\n  .lsn-login-account-desc {\n    margin-block: .5rem;\n    font-weight: bolder;\n  }\n\n  button.create-account {\n    margin-top: 1rem;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
